import { getAPIFromDomain } from "../../lib/api";

export interface BulkLostCsv {
  bulkLostCsv: File;
}

export const uploadBulkLostCsv = (data: BulkLostCsv) => {
  const { bulkLostCsv } = data;
  const api = getAPIFromDomain("logistics");
  const url = `/shipment_packages/bulk_mark_as_lost`;
  const formData = new FormData();
  formData.set("csv", bulkLostCsv);
  return api.post(url, formData);
};

export const downloadBulkLostCsvTemplate = () => {
  const api = getAPIFromDomain("logistics");
  const url = `/csv_templates/batch_lost_packages`;
  return api.get(url, {
    responseType: "blob",
  });
};
